// ---------------------------------------------------------------------------
// Stats / Counter Section
// ---------------------------------------------------------------------------
// Animated counters that roll up when scrolled into view.
// Each entry gets a big number + label.

const stats = [
  { value: 30, label: 'Students Mentored', suffix: '+' },
  { value: 4, label: 'Workshops Run', suffix: '' },
  { value: 3, label: 'Research Areas', suffix: '' },
  { value: 1, label: 'Patent Pending', suffix: '' },
];

export default stats;
